import {
  type CreateTRPCClientOptions,
  httpBatchLink,
  loggerLink,
} from '@trpc/client'
import { isTRPCClientError } from './utils.ts'

import { transformer } from '@mntn-dev/utilities'

import type { AppRouter } from '@mntn-dev/api'
import { route } from '@mntn-dev/app-routing'
import { AuthenticationError, isAuthenticationError } from '@mntn-dev/errors'
import { getClientRouteUrl } from '~/utils/client/get-url.ts'
import { errorLink } from './trpc-links.ts'

export const trpcClientConfig: CreateTRPCClientOptions<AppRouter> = {
  links: [
    errorLink({
      onError: (error) => {
        if (isTRPCClientError(error)) {
          if (isAuthenticationError(error.cause)) {
            window.location.href = route('/auth/logout').toRelativeUrl()
          }
        }
      },
    }),
    loggerLink({
      enabled: (opts) =>
        process.env.NODE_ENV === 'development' ||
        (opts.direction === 'down' && opts.result instanceof Error),
    }),
    httpBatchLink({
      transformer,
      url: getClientRouteUrl('api', 'trpc'),
      fetch: async (url, options) => {
        const res = await fetch(url, options)

        if (res.status === 401) {
          throw new AuthenticationError('Session expired', {
            code: 'expired_session',
          })
        }

        return res
      },
    }),
  ],
}
